import { Fragment, useEffect, useState } from "react"

export default function Confirm({ data, project, certificate_type, step, setStep, submit }) {

    const [ needUpdate, setNeedUpdate ] = useState(false)

    useEffect(() => {
        setNeedUpdate(false)
    }, [step])

    return (
        <Fragment>
            <div className="text-[1.5rem] font-semibold mb-2">
                {certificate_type?.label}
                {certificate_type?.shortcut === 'award' && '獲獎證明'} 申請
            </div>
            <div className="text-[0.875rem text-black-700 font-light mb-6">
                證明文件／獎狀印製之內容以競賽作品資訊為主，如有勘誤，請點選「資訊變更」進行修正，需等待人工審查後再寄送至申請者信箱。
            </div>
            <div className="text-[0.875rem] text-black-700 font-light mb-1">
                申請作品
            </div>
            <div className="mb-4">
                #{project.serial_no} {project.project_name}
            </div>
            <div className="text-[0.875rem] text-black-700 font-light mb-1">
                申請證書類別
            </div>
            <div className="mb-4">
                {data?.certificate_type?.label}
                {data?.certificate_type?.shortcut === 'award' && ' 獲獎證明'}
            </div>
            <div className="text-[0.875rem] text-black-700 font-light mb-1">
                作品標註校系
            </div>
            <div className="mb-4">
                {data?.units?.map((unit) => `${unit[0]} - ${unit[1]}`).join('、')}
            </div>
            <div className="text-[0.875rem] text-black-700 font-light mb-1">
                作品作者中文姓名
            </div>
            <div className="mb-4">
                {data?.applicant_names?.join('、')}
            </div>
            { data?.applicant_names_en?.length > 0 &&
                <Fragment>
                    <div className="text-[0.875rem] text-black-700 font-light mb-1">
                        作品作者英文姓名
                    </div>
                    <div className="mb-4">
                        {data?.applicant_names_en?.join('、')}
                    </div>
                </Fragment>
            }
            <div className="text-[0.875rem] text-black-700 font-light mb-1">
                指導老師
            </div>
            <div className="mb-6">
                { data?.advisor_names?.length === 0
                    ? '無'
                    : data?.advisor_names?.join('、')
                }
            </div>
            <div className="text-[1.125rem] font-semibold mb-3">
                資訊內容確認
            </div>
            <div className="input-group mb-9">
                <label className="!flex items-center gap-1.5">
                    <input
                        type="radio"
                        name="update"
                        onChange={() => { setNeedUpdate(false) }}
                        checked={!needUpdate}
                    />
                    <span className="font-light">
                        我已確認上述資訊無誤。
                    </span>
                </label>
                <label className="!flex items-center gap-1.5">
                    <input
                        type="radio"
                        name="update"
                        onChange={() => { setNeedUpdate(true) }}
                        checked={needUpdate}
                    />
                    <span className="font-light">
                        我需要申請變更資訊。
                    </span>
                </label>
            </div>
            { needUpdate
                ?
                <button
                    type="button"
                    className="w-full btn-black btn-round mb-3"
                    onClick={() => { setStep('update') }}
                >下一步</button>
                :
                <button
                    type="button"
                    className="w-full btn-black btn-round mb-3"
                    onClick={submit}
                >
                    送出申請
                </button>
            }
            <button
                type="button"
                className="w-full btn-outline-black btn-round"
                onClick={() => { setStep('info') }}
            >返回</button>
        </Fragment>
    )
}